import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import * as fromPigSig from '../fromPigSig.barrel';
import * as fromMessage from '../fromMessages.barrel';
import { map } from 'rxjs';
import { toastFactory } from 'src/app/models';
import { Guid } from '@tdw/core';

import * as fromMaintenance from '../fromSealingElement.barrel';

@Injectable()
export class MessagesEffects {


  constructor(private actions$: Actions) { }

  showFileNotFound$ = createEffect(() => this.actions$.pipe(
    ofType(fromPigSig.loadDwgFail),
    map(action => fromMessage.addToast({
      toast: toastFactory({
        message: action?.error?.error || 'File not found',
        class: 'danger',
        delay: 4000,
        id: Guid.newGuid(),
        title: 'File not found',
        icon: 'fa fa-exclamation-circle'
      })
    }))
  ));

  showMessageAfterExtract$ = createEffect(() => this.actions$.pipe(
    ofType(fromMaintenance.extractDataFromTemplateSuccess),
    map(action => fromMessage.addToast({
      toast: toastFactory({
        message: 'File upload and data was updated',
        class: 'success',
        delay: 4000,
        id: Guid.newGuid(),
        title: 'Import complete',
        icon: 'fa fa-thumbs-up'
      })
    }))
  ));
}
